
import React from "react";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";
import { ITeamMember, ITeamWebsite } from "../../../../../services";
import ScrollTrack, { ScrollButtons, useScroller } from "../common/ScrollTrack";

export interface SquadCarouselProps {
    website: ITeamWebsite;
    members: ITeamMember[];
    onSelect: (m: ITeamMember) => void;
}

function SquadCarousel({ website, members, onSelect }: SquadCarouselProps) {

    const scroller = useScroller();

    return (<section className={styles["squad"]}>
        <div className={styles["container"]}>
            <div className={styles["row-head"]}>
                <div>
                    <h2 className={styles["section-title"]}><strong>{website.team.name}</strong></h2>
                    <span className={styles["subtitle"]}>{i18nManager.Labels.home.squad_kicker}</span>
                </div>
                {members.length > 1 && (<ScrollButtons onPrev={scroller.prev} onNext={scroller.next} />)}
            </div>
        </div>
        <ScrollTrack trackRef={scroller.ref} className={styles["track-squad"]}>
            {members.map((m) => (<button key={m.external_id} className={styles["squad-card"]} onClick={() => onSelect(m)}>
                <span className={styles["squad-card-inner"]}>
                    <img className={styles["squad-card-img"]} src={m.half_body_picture_url || m.passport_picture_url} alt="" loading="lazy" />
                    <span className={styles["squad-card-title"]}>
                        <span>{m.display_name}</span>
                        {m.extra_data?.team_role && (<small>{m.extra_data.team_role}</small>)}
                    </span>
                </span>
            </button>))}
        </ScrollTrack>
    </section>);
}

export default SquadCarousel;
